import React from 'react';

// BL-117 — the Docs editor's left rail: a two-level section / sub-section tree.
// Reorder is via up/down buttons (mirrors the Path editor's steps outline).
const Row = ({ section, active, isTop, first, last, onSelect, onMove, onRemove, onAddSub }) => (
  <div className={`doc-trow ${isTop ? '' : 'is-child'} ${active ? 'on' : ''}`}>
    <span className="doc-trow__t" onClick={() => onSelect(section.id)} title={section.title}>
      {section.title || 'Untitled'}
      {section.is_group && <span className="doc-trow__g">Group</span>}
    </span>
    <span className="doc-trow__acts">
      <button type="button" title="Move up" disabled={first} onClick={() => onMove(section.id, 'up')}>↑</button>
      <button type="button" title="Move down" disabled={last} onClick={() => onMove(section.id, 'down')}>↓</button>
      {isTop && <button type="button" title="Add subsection" onClick={() => onAddSub(section.id)}>＋</button>}
      <button type="button" title="Remove" onClick={() => onRemove(section.id)}>✕</button>
    </span>
  </div>
);

const SectionTree = ({ sections, activeId, onSelect, onAddSection, onAddSub, onMove, onRemove }) => (
  <div className="doc-tree">
    <div className="doc-tree__head">Sections</div>
    <div className="doc-tree__list">
      {sections.length === 0 && <div className="doc-tree__empty">No sections yet.</div>}
      {sections.map((s, i) => (
        <div key={s.id} className="doc-tree__group">
          <Row
            section={s}
            active={activeId === s.id}
            isTop
            first={i === 0}
            last={i === sections.length - 1}
            onSelect={onSelect}
            onMove={onMove}
            onRemove={onRemove}
            onAddSub={onAddSub}
          />
          {(s.children || []).map((c, ci) => (
            <Row
              key={c.id}
              section={c}
              active={activeId === c.id}
              isTop={false}
              first={ci === 0}
              last={ci === s.children.length - 1}
              onSelect={onSelect}
              onMove={onMove}
              onRemove={onRemove}
            />
          ))}
        </div>
      ))}
    </div>
    <div className="doc-tree__add" onClick={onAddSection}>＋ Add section</div>
  </div>
);

export default SectionTree;
